"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_redux_1 = require("react-redux");
const transactionSigningAction_1 = require("@/features/transaction-signing/actions/transactionSigningAction");
const constants_1 = require("../constants");
const OTPStyle_1 = __importDefault(require("./styles/OTPStyle"));
const transactionSigningSelector_1 = require("../selectors/transactionSigningSelector");
const material_1 = require("@mui/material");
const TransactionSigningOTP = ({ onClose }) => {
    const classes = (0, OTPStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [otpError, setOtpError] = (0, react_1.useState)({});
    const { showTransactionSigningOTP, showResendOTPSuccess, maskedMobileNo, otpCode, resetIndicator, dynamicLabel } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const handleOtpInputChange = (event) => {
        const { value } = event.target;
        if (value && value.length > 6) {
            return;
        }
        dispatch((0, transactionSigningAction_1.setOtpCode)(value));
    };
    const handleToggleSubmitOTP = () => {
        console.log('handleToggleSubmitOTP');
        if (otpCode && otpCode.length === 6) {
            setOtpError({});
            console.log('handleToggleSubmitOTP');
            dispatch((0, transactionSigningAction_1.toggleSubmitOtp)());
        }
        else {
            setOtpError(constants_1.SYSTEM_MESSAGES_TRANSACTION_SIGNING.OTP_ERROR_EMPTY_OTP);
        }
    };
    const handleToggleSubmitOtpNoAuthorizationStatus = () => {
        console.log('handleToggleSubmitOTPNoAuthorizationStatus');
        if (otpCode && otpCode.length === 6) {
            setOtpError({});
            console.log('handleToggleSubmitOTPNoAuthorizationStatus');
            dispatch((0, transactionSigningAction_1.toggleSubmitOtpNoAuthorizationStatus)());
        }
        else {
            setOtpError(constants_1.SYSTEM_MESSAGES_TRANSACTION_SIGNING.OTP_ERROR_EMPTY_OTP);
        }
    };
    const toggleClose = () => {
        dispatch((0, transactionSigningAction_1.dismissResendOTPSuccessLayout)());
        dispatch((0, transactionSigningAction_1.dismissTransactionSigningOTPLayout)());
        onClose();
    };
    const handleToggleResendNotification = () => {
        console.log('handleToggleResendNotification');
        dispatch((0, transactionSigningAction_1.toggleResendNotification)());
    };
    return (react_1.default.createElement(material_1.Dialog, { open: showTransactionSigningOTP, classes: { paper: classes.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { className: classes.DialogContentOuter },
            react_1.default.createElement("div", { className: classes.TitleOutline },
                react_1.default.createElement("div", { className: classes.TitleContent },
                    react_1.default.createElement(material_1.Typography, { className: classes.OneTokenTitle, variant: "h1" }, dynamicLabel && dynamicLabel.length > 0 ? dynamicLabel : react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-title" })),
                    react_1.default.createElement(material_1.Link, { className: classes.IconClose, onClick: toggleClose }))),
            react_1.default.createElement(material_1.DialogContent, null,
                showResendOTPSuccess ? (react_1.default.createElement(material_1.Container, { className: classes.notifySuccess },
                    react_1.default.createElement(material_1.Container, { className: classes.notifyInnerContent },
                        react_1.default.createElement(material_1.ListItem, { className: classes.notifySuccessText },
                            react_1.default.createElement(material_1.ListItemIcon, { className: classes.NotifySuccessIcon }),
                            react_1.default.createElement(material_1.ListItemText, null,
                                react_1.default.createElement(material_1.Typography, { className: `${classes.notifyTips1} ${classes.commonWordStyle}` },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-notify-success" })),
                                react_1.default.createElement(material_1.Typography, { className: `${classes.notifyTips2} ${classes.commonWordStyle} ${classes.fontInfo}` },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-notify-success-tips" }))))))) : null,
                react_1.default.createElement(material_1.ListItem, { className: classes.ListItem },
                    react_1.default.createElement(material_1.ListItemIcon, { className: classes.WrapIcon }),
                    react_1.default.createElement(material_1.ListItemText, { className: classes.ListItemText },
                        react_1.default.createElement(material_1.Typography, { className: classes.SMSTips },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-sms-tips-1" }),
                            " ",
                            maskedMobileNo,
                            ".",
                            react_1.default.createElement("br", null),
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-sms-tips-2" })),
                        react_1.default.createElement(material_1.Container, { className: classes.OTPInputOutline },
                            react_1.default.createElement(material_1.Typography, { className: `${classes.OTPInputTitle} ${classes.SMSTips}` },
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-input-title" })),
                            react_1.default.createElement(material_1.Container, { className: classes.OTPInput },
                                react_1.default.createElement(material_1.Container, { className: classes.OPTInputContent },
                                    react_1.default.createElement(material_1.Input, { className: classes.OTP, classes: { input: classes.InputHeight, focused: classes.InputFocus }, fullWidth: true, type: "password", name: "OTP", value: otpCode, onChange: handleOtpInputChange, disableUnderline: true }))),
                            react_1.default.createElement(material_1.Container, { className: classes.resendLink },
                                react_1.default.createElement(material_1.Link, { className: classes.Link, onClick: handleToggleResendNotification },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-resend" })))),
                        otpError && Object.keys(otpError).length > 0 ? (react_1.default.createElement(material_1.Container, { className: classes.OtpError },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: otpError.msgId, defaultMessage: otpError.defaultMsg }))) : null,
                        react_1.default.createElement(material_1.Typography, { className: `${classes.resendTips} ${classes.fontInfo}` },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-resend-tips1" })),
                        react_1.default.createElement(material_1.Typography, { className: `${classes.updateMobileTips} ${classes.fontInfo}` },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-resend-tips2" }),
                            ' ',
                            react_1.default.createElement("a", { target: "_blank", href: "https://hdhwhhk.com/business-banking/en/accounts-and-payments/velocity-manageaccount-form-en.pdf", className: classes.formLink, rel: "noopener noreferrer" },
                                ' ',
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-resend-tips3" })),
                            ' ',
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-resend-tips4" })))),
                react_1.default.createElement(material_1.Typography, { variant: "h2", className: classes.bodyTitle }),
                resetIndicator === 'Unlock2FA' ? (react_1.default.createElement(material_1.Container, { className: classes.SubmitOutline },
                    react_1.default.createElement(material_1.Button
                    // className={classes.Submit}
                    , { 
                        // className={classes.Submit}
                        disableTouchRipple: true, variant: "contained", onClick: handleToggleSubmitOtpNoAuthorizationStatus },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-submit" })))) : (react_1.default.createElement(material_1.Container, { className: classes.SubmitOutline },
                    react_1.default.createElement(material_1.Button
                    // className={classes.Submit}
                    , { 
                        // className={classes.Submit}
                        disableTouchRipple: true, variant: "contained", onClick: handleToggleSubmitOTP },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "transaction-signing-one-time-password-submit" }))))))));
};
exports.default = TransactionSigningOTP;
